import axiosInstance from '../api/axiosInstance';
import { CreateCategoryDto, CategoryListResponseDto, CategorySingleResponseDto, GenericResponseDto } from '../dtos/CategoryDto';

export class CategoryRepository {
    static async getAll(): Promise<CategoryListResponseDto> {
        const response = await axiosInstance.get<CategoryListResponseDto>('/admin/categories');
        return response.data;
    }
 
    static async getById(id: number): Promise<CategorySingleResponseDto> {
        const response = await axiosInstance.get<CategorySingleResponseDto>(`/admin/categories/${id}`);
        return response.data;
    }

    static async create(data: CreateCategoryDto): Promise<CategorySingleResponseDto> {
        const response = await axiosInstance.post<CategorySingleResponseDto>('/admin/categories', data);
        return response.data;
    }
 
    static async update(id: number, data: CreateCategoryDto): Promise<CategorySingleResponseDto> {
        // Postman didn't show PUT/PATCH but usually it exists.
        // If not, use standard pattern.
        console.log(data);
        const response = await axiosInstance.put<CategorySingleResponseDto>(`/admin/categories/${id}`, data);
        return response.data;
    }

    static async delete(id: number): Promise<GenericResponseDto> {
        const response = await axiosInstance.delete<GenericResponseDto>(`/admin/categories/${id}`);
        return response.data;
    }
}
